<template>
  <div class="me-view">
    <div class="me-view-container">
      <eg-card>
        <div class="account-header">
          <div class="top-row d-flex justify-content-between">
            <div class="heading-s">{{ $t("account.myDetails") }}</div>
            <eg-button icon="pen-edit" type="secondary" @click="edit">{{
              $t("account.editDetails")
            }}</eg-button>
          </div>

          <div class="bottom-row">
            <div class="paragraph-s medium">{{ $t("account.avatar") }}</div>

            <div class="avatar-container">
              <user-avatar v-if="user" :user="user" :avatar-size="64" />

              <!-- <div class="avatar-container-actions">
                <eg-button type="secondary">{{ $t('account.uploadPhoto') }}</eg-button>
                <eg-button type="secondary" color="danger">Remove</eg-button>
              </div> -->
            </div>
          </div>
        </div>

        <div class="divider" />

        <div class="">
          <div class="paragraph-s medium">{{ $t("account.fullName") }}</div>
          <div class="name-container">
            <div class="button-l color-text-neutral-secondary">
              {{ username }}
            </div>
          </div>
        </div>

        <div class="divider" />

        <div>
          <div class="paragraph-s medium">{{ $t("account.email") }}</div>
          <div class="email-container">
            <div class="button-l color-text-neutral-secondary">
              {{ user.email }}
            </div>
          </div>
        </div>

        <div class="divider" />

        <div>
          <div class="paragraph-s medium">{{ $t("account.password") }}</div>
          <div class="password-container">
            <div class="password-address">********</div>
          </div>
        </div>
      </eg-card>

      <div class="right-side">
        <eg-card>
          <div class="d-flex justify-content-between">
            <div class="widget-box">
              <div class="paragraph-s medium">
                {{ $t("account.timeSaved") }}
              </div>
              <div class="heading-l semi-bold">
                {{ formatTimeSaved(accountProvider.usage?.savings?.time) }}
              </div>
            </div>

            <img
              src="@/assets/icons/save_time.svg"
              alt="Clock"
              class="widget-box-icon"
            />
          </div>
        </eg-card>

        <plan-banner :title="$t('account.usageThisMonth')" />
      </div>

      <eg-card class="danger-zone">
        <div class="heading-s">{{ $t("account.dangerZone") }}</div>

        <div class="d-flex justify-content-between">
          <div class="paragraph-s medium">
            {{ $t("account.deleteThisAccount") }}
          </div>
          <eg-button type="secondary" color="danger" @click="deleteAccount">{{
            $t("account.deleteAccount")
          }}</eg-button>
        </div>
      </eg-card>
    </div>
  </div>
</template>

<script>
import { capitalize } from "@/utils/capitalize";
import { formatTimeSaved } from "@/utils/format";
import UserAvatar from "@/components/global/user_avatar.vue";
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import EgCard from "@/components/global/eg_card.vue";
import deleteConfirmationModalMixin from "@/mixins/deleteConfirmationModal";
import PlanBanner from "@/components/global/planBanner/plan-banner.vue";
import { deleteAccount } from "@/api";

export default {
  name: "AccountMeView",

  components: {
    UserAvatar,
    EgButton,
    EgCard,
    PlanBanner,
  },

  mixins: [deleteConfirmationModalMixin],

  inject: ["accountProvider"],

  computed: {
    user() {
      return this.$store.state.user || {};
    },
    username() {
      return `${capitalize(this.user?.firstName || "")} ${capitalize(
        this.user?.lastName || ""
      )}`;
    },
  },

  methods: {
    formatTimeSaved,

    edit() {
      this.$getClerk().openUserProfile();
    },

    async deleteAccount() {
      try {
        const confirm = await this.showDeleteConfirmationModal({
          title: this.$t("account.deleteAccount"),
          message: this.$t("account.deleteAccountMessage"),
          confirmTextLabel: this.$t("account.deleteAccountConfirmLabel"),
          confirmTextValue: "DELETE",
        });

        if (!confirm) return;

        await deleteAccount(this.user.id);
        this.$getClerk()?.signOut();
        await this.$store.dispatch("logout");
      } catch (error) {
        console.log(error);

        this.$showToastError(error.message, { title: this.$t("common.error") });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.me-view {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .me-view-container {
    display: grid;
    gap: 24px;
    grid-template-columns: 3fr 1fr;
  }

  .right-side {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .eg-card {
      padding: 16px;
    }
  }

  .widget-box {
    display: flex;
    flex-direction: column;
    gap: 9px;
  }

  .widget-box-icon {
    opacity: 0.3;

    &.money {
      width: 75px;
    }
  }

  .progress-bar-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .progress {
      height: 6px;
      margin-bottom: 8px;
    }
  }

  .danger-zone {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .divider {
    margin: 16px 0;
  }

  .bottom-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .account-header {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .avatar-container {
    display: flex;
    gap: 16px;
    align-items: center;

    .avatar-container-actions {
      display: flex;
      gap: 12px;
    }
  }
  .right-side .plan-banner {
    padding: 1rem;
  }
}
</style>
